import styled, { keyframes } from 'styled-components';

const LoadingOverlay = ({ message = '처리 중입니다...', minimal = false }) => (
  <Backdrop>
    {minimal ? (
      <MinimalCenter>
        <SpinnerLight />
        {message ? <MinimalMsg>{message}</MinimalMsg> : null}
      </MinimalCenter>
    ) : (
      <Box>
        <Spinner />
        <Msg>{message}</Msg>
      </Box>
    )}
  </Backdrop>
);

export default LoadingOverlay;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const Box = styled.div`
  background: #fff;
  border-radius: 14px;
  padding: 28px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  min-width: 220px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.18);
`;

const Spinner = styled.div`
  width: 38px;
  height: 38px;
  border: 4px solid ${({ theme }) => theme.colors.borderLight};
  border-top-color: ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  animation: ${spin} 0.9s linear infinite;
`;

const Msg = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text};
  text-align: center;
  line-height: 1.55;
  white-space: pre-line;
`;

const MinimalCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
`;

const SpinnerLight = styled.div`
  width: 44px;
  height: 44px;
  border: 4px solid rgba(255, 255, 255, 0.25);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: ${spin} 0.9s linear infinite;
`;

const MinimalMsg = styled.p`
  margin: 0;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  font-weight: 500;
  line-height: 1.55;
  white-space: pre-line;
`;
